import clsx from 'clsx'

interface SegmentedProps<T extends string> {
    value: T
    options: { value: T; label: string }[]
    onChange: (value: T) => void
}

/**
 * Pill-style switch between a small number of mutually exclusive views.
 */
export function Segmented<T extends string>({ value, options, onChange }: SegmentedProps<T>) {
    return (
        <div className="inline-flex rounded-lg bg-neutral-100 p-0.5">
            {options.map((option) => (
                <button
                    key={option.value}
                    type="button"
                    onClick={() => onChange(option.value)}
                    className={clsx(
                        'rounded-md px-3 py-1.5 text-md font-medium transition',
                        value === option.value
                            ? 'bg-white text-dark shadow-xs'
                            : 'text-neutral-500 hover:text-neutral-700',
                    )}>
                    {option.label}
                </button>
            ))}
        </div>
    )
}

export default Segmented
